import { useState } from "react";
import { useAuth } from "../../components/context/Auth";
import Button from "../../components/updatedComponents/Dealers/Button";
import styles from "../dashboard/Dispatch.module.css";

const AcceptOrderModal = ({
  handleCloseModal,
  heading,
  centerHeading,
  handleSubmit,
  targetWord,
}) => {
  const { mode } = useAuth();

  const cH = centerHeading?.split(new RegExp(`(${targetWord})`, "gi"));

  const getColor = (word) => {
    const redWords = [
      "logout",
      "logoff",
      "cancel",
      "decline",
      "disabled",
      "remove",
    ];
    const greenWords = ["create", "settle"];

    if (redWords.includes(word)) return "#F93E39";
    if (greenWords.includes(word)) return "#34A853";

    switch (word) {
      case "update":
        return "#4164E3";
      case "order":
        return "#FF8000";
      case "delete":
        return "#F93E3E";
      default:
        return "#000";
    }
  };

  const color = getColor(targetWord);

  const [loading, setLoading] = useState(false);

  const handleModalSubmit = async () => {
    try {
      setLoading(true);
      await handleSubmit();
      handleCloseModal(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Submission failed:", error);
    }
  };

  return (
    <div
      className={styles.accept_order}
      style={{ backgroundColor: mode ? "#232529" : "#fff" }}
    >
      <p
        className={styles.bold_text}
        style={{ alignSelf: "flex-start", color: mode ? "#ffffff" : "#000" }}
      >
        {heading}
      </p>
      <img src="/assets/updatedAssets/logout_img.png" alt="" />

      <p
        className={`${styles.bold_text}`}
        style={{ color: mode ? "#ffffff" : "#000" }}
      >
        {cH?.map((part, index) =>
          part?.toLowerCase() === targetWord?.toLowerCase() ? (
            <span key={index} style={{ color }}>
              {part}
            </span>
          ) : (
            <span key={index}>{part}</span>
          )
        )}
      </p>

      <div className={styles.bottom_buttons}>
        <div style={{ width: "30%" }}>
          <Button
            buttonText={"No"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={handleCloseModal}
            tabIndex={-1}
          />
        </div>
        <div style={{ width: "30%" }}>
          <Button
            buttonText={"Yes"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
            buttonBorder={"none"}
            buttonClick={handleModalSubmit}
            tabIndex={-1}
            loading={loading}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default AcceptOrderModal;
